import {ProductsResponse} from '../../types/Favorites';
import AxiosService from '../AxiosService';
interface INotificationCount {
  count: number;
}

const GetCountNotifications = async (
): Promise<INotificationCount> => {
  const instance = AxiosService.createAuthAxiosInstance();
  const response = await instance.get('v1/client/inapp-notifications/count');
  return response.data;
};

const GetNotifications = async (
  page: number,
  per_page: number,
) => {
  const instance = AxiosService.createAuthAxiosInstance();
  const response = await instance.get(
    `v1/client/inapp-notifications?page=${page}&per_page=${per_page}`,
  );
  return response.data;
}

const MarkNotificationAsRead = async (notificationId: string) => {
  const instance = AxiosService.createAuthAxiosInstance();
  const response = await instance.put(
    `v1/client/inapp-notifications/${notificationId}/read`,
  );
  return response.data;
}

const ClearAllNotifications = async () => {
  const instance = AxiosService.createAuthAxiosInstance();
  const response = await instance.delete(
    'v1/client/inapp-notifications/clear-all',
  );
  return response.data;
}

export default {
    GetCountNotifications,
    GetNotifications,
    MarkNotificationAsRead,
    ClearAllNotifications,
};
